import BaseAPIClient from './backend';
import type { BackendUser } from '../types/user';

export class UserService extends BaseAPIClient {
  async getMe(): Promise<BackendUser> {
    return this.request<BackendUser>(() => this.client.get('/users/me'));
  }
}
